import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'

const EccChip = () => (
  <Tooltip title="ECC RAM">
    <Chip
      label="ECC"
      size="small"
      sx={{
        height: 18,
        fontSize: '0.65rem',
        fontWeight: 700,
        letterSpacing: 0.5,
        background: 'linear-gradient(90deg, #e6b01c 0%, #d4785c 100%)',
        color: 'rgba(0, 0, 0, 0.87)',
      }}
    />
  </Tooltip>
)

export default EccChip
